import React from 'react'

const Toys = () => {
  return (
    <div>Toys</div>
  )
}

export default Toys